module.exports = __webpack_public_path__ + "media/src/img/ban-1-54760b2cb97417b350a600908f187abc.svg";